<head>
  <link rel="stylesheet" href="login.component.css" />
</head>

<body>
  <div *ngIf="submissionComplete" class="submission-toast">
    <button class="close-btn" (click)="submissionComplete = false">×</button>
    <img src="https://delightful-desert-06d2acd0f.6.azurestaticapps.net/assets/unipet_text.png" alt="Unipet Logo" style="max-height: 50px;">
    <p>Your registration was successful! Please log in to view your submission.</p>
  </div>
  

  <div class="left-half">
    <img [src]="bgImage" alt="Background" />
  </div>

  <div class="right-half">
    <div class="login-wrapper">
      <div class="form-head">
        <h2>{{ loginhead }}</h2>
      </div>

      <form (ngSubmit)="onSubmit()" #loginForm="ngForm">

        <div class="input-field">
          <i class="material-icons prefix">account_circle</i>
          <input type="text" placeholder="Email Address" [(ngModel)]="username" name="username" required />
        </div>

        <div class="input-field" style="position: relative;">
          <i class="material-icons prefix">lock</i>
        
          <input
            [type]="hidePassword ? 'password' : 'text'"
            placeholder="Password"
            [(ngModel)]="password"
            name="password"
            required
          />
        
          <i
            class="material-icons password-visibility"
            (click)="hidePassword = !hidePassword"
          >
            {{ hidePassword ? 'visibility' : 'visibility_off' }}
          </i>
        </div>
        
        
        <p class="error" *ngIf="error_message">{{ error_message }}</p>

        <div *ngIf="loading" class="overlay">
          <div class="spinner"></div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn btn-login">Sign In</button>
        </div>

        <div class="links">
          <a [routerLink]="'/reset_password'">Forgot Password?</a>
          <a [routerLink]="'/'">Submit a New Form</a>
        </div>
      </form>

      <div class="divider-label">Admin Only</div>

      <button class="ms-signin-button" (click)="Mslogin()">
        <img
          src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/microsoft.svg"
          alt="Microsoft logo"
          class="ms-icon"
        />
        <span>Sign in with Microsoft</span>
      </button>
    </div>
  </div>
</body>
